import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bookmarkService } from '../api/services';
import { formatDate, truncateText, getPostPrimaryBadgeLabel, getPostPrimaryBadgeColor } from '../utils/helpers';
import './BookmarksPage.css';

const BookmarksPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBookmarks = async () => {
      try {
        const res = await bookmarkService.list();
        setPosts(res.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBookmarks();
  }, []);

  // 移除收藏後直接從本地清單抽掉該筆，避免重新打 API
  const handleRemove = async (e, postId) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await bookmarkService.remove(postId);
      setPosts((prev) => prev.filter((p) => p.id !== postId));
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div className="container mt-5">載入中...</div>;

  return (
    <div className="bookmarks-page">
      <div className="container">
        <div className="page-header">
          <h1>我的收藏</h1>
          <p>你標記起來、想之後回頭看的文章</p>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {posts.length === 0 ? (
          <div className="empty-state">
            <p>還沒有收藏任何文章，去<Link to="/">首頁</Link>逛逛吧</p>
          </div>
        ) : (
          <div className="posts-list">
            {posts.map((post) => (
              <div key={post.id} className="post-card">
                <div className="post-header">
                  <Link to={`/posts/${post.id}`} className="post-title">{post.title}</Link>
                  <div className="post-badges">
                    <span className={`badge badge-${getPostPrimaryBadgeColor(post)}`}>
                      {getPostPrimaryBadgeLabel(post)}
                    </span>
                  </div>
                </div>
                <p className="post-excerpt">{truncateText(post.content, 150)}</p>
                <div className="post-meta">
                  <span className="author">作者: {post.author_name}</span>
                  <span className="stat-pill">👍 {post.vote_count || 0}</span>
                  <span className="stat-pill">💬 {post.comment_count || 0}</span>
                  <span className="time">收藏於 {formatDate(post.bookmarked_at)}</span>
                  <button className="btn-bookmark bookmarked" onClick={(e) => handleRemove(e, post.id)}>
                    ★ 取消收藏
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BookmarksPage;
